import Swal from 'sweetalert2';
import { useSocket } from '../hooks/useSocket';
import { Primary } from '../constants';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import RouterProvider from '../routers/RouterProvider';
import { BotHealthStatus } from '../types/Bot';

const GlobalSocketEvents = () => {
  const { t } = useTranslation();

  useSocket('failed-video-traininig', (err: any) => {
    console.error('❌ Failed video training (global):', err);
    Swal.fire({
      title: t('global.socket.titleError'),
      text: t('global.socket.videoTrainingFailedText'),
      icon: 'error',
      confirmButtonColor: Primary,
    });
  });
  useSocket(
    'video-trained',
    (data: { filename: string; threadId: string; id: number; videoUrl: string }) => {
      console.log('🎉 Video trained (global):', data.filename);
      Swal.fire({
        title: t('global.socket.titleSuccess'),
        text: t('global.socket.videoTrainedText', {
          filename: data.filename,
        }),
        icon: 'success',
        confirmButtonColor: Primary,
      });
    },
  );
  useSocket(
    'bot-state-changed',
    (data: { botId: string; oldState: string; newState: string; createdAt: string }) => {
      if (data.newState === 'joining') {
        toast.warning('Bot joining', {
          autoClose: 10000,
          closeOnClick: true,
        });
      }
      if (data.newState === 'joined_not_recording') {
        toast.warning('Bot joined, but not recording', {
          autoClose: 10000,
          closeOnClick: true,
        });
      }
      if (data.newState === 'joined_recording') {
        toast.success('Bot started recording', {
          autoClose: 10000,
          closeOnClick: true,
        });
      }
      if (data.newState === 'fatal_error') {
        // show a non-dismissible modal so it appears over all pages
        Swal.fire({
          title: t('bot.fatalErrorTitle'),
          text: t('bot.fatalErrorText', { botId: data.botId }) || 'Bot encountered a fatal error',
          icon: 'error',
          confirmButtonColor: Primary,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCloseButton: false,
          confirmButtonText: t('global.ok'),
        });
        //   .then((result) => {
        //   if (result.isConfirmed) {
        //     RouterProvider.navigate(`/bots/${data.botId}`);
        //   }
        // });

        // toast.error('Bot encountered a fatal error', {
        //   autoClose: false,
        //   closeOnClick: true,
        // });
      }
      // if (data.newState === 'leaving') {
      //   toast.warn('Bot leaving', {
      //     autoClose: false,
      //     closeOnClick: true,
      //   });
      // }
      // if (data.newState === 'post_processing') {
      //   toast.info('Bot processing meet', {
      //     autoClose: false,
      //     closeOnClick: true,
      //   });
      // }
      if (data.newState === 'ended') {
        toast.info('Bot stoped', {
          autoClose: 10000,
          closeOnClick: true,
        });
      }
      // You can show a toast or update UI here
    },
  );
  useSocket(
    'answers:fail',
    (data: {
      assistantExam: number | null; // if assistantExam can be null
      exam: number;
      user: {
        id: number;
        email: string;
        firstName: string;
        lastName: string;
      } | null;

      score: number;
      failedScoring: boolean;
      rawResponse?: string | null;
    }) => {
      toast.error(t('scoring.toastErrorText', { email: data.user?.email ?? 'user' }), {
        position: 'top-right',
        autoClose: 5000,
        onClick() {
          RouterProvider.navigate(`/exams/details/${data.exam}`);
        },
        theme: 'light',
        closeOnClick: true,
      });
    },
  );

  useSocket(
    'answers:success',
    (data: {
      assistantExam: number | null; // if assistantExam can be null
      exam: number;
      user: {
        id: number;
        email: string;
        firstName: string;
        lastName: string;
      } | null;

      score: number;
      failedScoring: boolean;
      rawResponse?: string | null;
    }) => {
      toast.success(t('scoring.toastSuccessText', { email: data.user?.email ?? 'user' }), {
        position: 'top-right',
        autoClose: 5000,
        onClick() {
          RouterProvider.navigate(`/exams/details/${data.assistantExam}`);
        },
        theme: 'light',
        closeOnClick: true,
      });
    },
  );
  useSocket('bot-connect-error', (data: BotHealthStatus) => {
    console.log('❌ Bot connection error (global):', data);
    Swal.fire({
      title: t('bot.connectionErrorTitle'),
      text:
        t('bot.connectionErrorText', { botId: data.id }) || 'Bot encountered a connection error',
      icon: 'error',
      confirmButtonColor: Primary,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: false,
      confirmButtonText: t('global.ok'),
    });
  });
  useSocket(
    'last-try-score-error',
    (data: {
      assistantExamId: number;
      errorMessage: string;
      botId: string | null;
      attempts: number;
      retryLimit: number;
    }) => {
      console.log('❌ Last try score error (global):', data);
      const parsedError: {
        message: string;
        error: string;
        statusCode: number;
      } = JSON.parse(data.errorMessage);
      Swal.fire({
        title: t('scoring.socket.lastTryErrorTitle'),
        text: t('scoring.socket.lastTryErrorText', {
          attempt: data.attempts,
          assistantExamId: data.assistantExamId,
          message: parsedError.message,
          error: parsedError.error,
        }),
        icon: 'error',
        confirmButtonColor: Primary,
      });
    },
  );

  return null;
};

export default GlobalSocketEvents;
